import actionTypes from './actionTypes';

export const addToRecentGlobalSearches = (searchValue) => ({
  type: actionTypes.GLOBAL_SEARCH_ADD_TO_RECENT,
  payload: searchValue,
});

export const clearRecentGlobalSearches = () => ({
  type: actionTypes.GLOBAL_SEARCH_CLEAR_RECENT,
});
